var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEmai(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.5 5.25A2.25 2.25 0 003.25 7.5v9a2.25 2.25 0 002.25 2.25h13a2.25 2.25 0 002.25-2.25V7.764 7.5a2.25 2.25 0 00-2.25-2.25h-13zm13.73 2.073a.75.75 0 00-.73-.573h-13a.75.75 0 00-.729.573l7.23 4.066 7.228-4.066zM4.75 9.033V16.5c0 .414.336.75.75.75h13a.75.75 0 00.75-.75V9.032l-6.882 3.872a.75.75 0 01-.736 0L4.75 9.032z",
    fill: "currentColor"
  })));
}

export default SvgEmai;